const FSE_CONTAINER = 'fseContainer';
const FSE_MESSAGE = 'fseMessage';

export { FSE_CONTAINER, FSE_MESSAGE };
